import React from 'react'
import routes from '../config/settings/routes'
import ManagementSectionContainer from '../containers/ManagementMenu/ManagementMenu.container'
import NavbarContainer from '../containers/Navbar/Navbar.container'
import BrandLayout from '../components/Layouts/BrandLayout'
import Heading from '../components/Layouts/Heading'
import ProtectByFeatures from '../components/Security/ProtectByFeatures'
import ProtectBySession from '../components/Security/ProtectBySession'
import NotFoundPage from './NotFound'
import FuelManagementContainer from '../containers/FuelManagement/FuelManagement.container'
import FuelManagementTopbar from '../containers/FuelManagement/FuelManagementTopbar.container'

/**
 * The Fuel Management's page.
 */
const FuelManagement = () => {
  const title = 'Control de combustible'

  return (
    <ProtectBySession rule={(hasSession, signedIn) => !!(hasSession && signedIn)}>
      <ProtectByFeatures rule={features => features['com.cosmos/fuel_management']} fallback={() => <NotFoundPage />}>
        <BrandLayout
          navbar={<NavbarContainer />}
          header={<Heading title={title} topbar={FuelManagementTopbar} />}
          sidebar={<ManagementSectionContainer current={routes.fuelManagement} />}
        >
          <FuelManagementContainer />
        </BrandLayout>
      </ProtectByFeatures>
    </ProtectBySession>
  )
}

export default FuelManagement
